import React, { FC, useRef, useState } from 'react';

import { TooltipBox, TooltipTarget, TooltipWrapper, WrapCenter } from './styled';
import { Position, TextAlign } from './types';

interface ITooltipProps {
  text: string;
  children: React.ReactNode;
  position?: Position;
  textAlign?: TextAlign;
  showOnFocus?: boolean;
}

const Tooltip: FC<ITooltipProps> = ({
  children,
  text,
  position = Position.TOP,
  textAlign = TextAlign.LEFT,
  showOnFocus = true
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const handleMouseOver = () => setIsHovered(true);
  const handleMouseOut = () => setIsHovered(false);
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);
  const targetRef = useRef<HTMLButtonElement>(null);

  const showTooltip = isHovered || (showOnFocus && isFocused);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (targetRef.current) {
      targetRef.current.blur();
    }
  };

  return (
    <TooltipWrapper>
      <TooltipTarget
        onMouseEnter={handleMouseOver}
        onMouseLeave={handleMouseOut}
        onFocus={handleFocus}
        onBlur={handleBlur}
        showOnFocus={showOnFocus}
        onClick={handleClick}
        ref={targetRef}
      >
        {children}
      </TooltipTarget>
      {showTooltip && (
        <WrapCenter position={position}>
          <TooltipBox showTooltip={showTooltip} position={position} textAlign={textAlign}>
            {text}
          </TooltipBox>
        </WrapCenter>
      )}
    </TooltipWrapper>
  );
};

export default Tooltip;
